import { Component } from '@angular/core';

@Component({
  selector: 'app-my-clubs-content',
  templateUrl: './my-clubs-content.component.html',
  styleUrls: ['./my-clubs-content.component.css']
})
export class MyClubsContentComponent {

}
